import { EditPageTemplate } from "../../EditPageTemplate";
import { mt } from "../../../../utils/tracking";
import { useState } from "react";
import { UpdateStatus } from "../../ContactInfo.types";

import styles from "./DocumentDelivery.module.scss";
import { usePolicySummaries } from "../../../../hooks/usePolicySummaries";
import { NotFound } from "../../../../not-found";

export default function DocumentDeliveryPage() {
  const policies = usePolicySummaries();
  const hasCorePolicy = !!policies && policies.some((p) => p.source === "CORE");
  const isUSPolicyHolder =
    !!policies && policies.some((p) => p.country === "USA");

  if (!hasCorePolicy || !isUSPolicyHolder) {
    return <NotFound />;
  }

  return <DocumenDeliveryPageWrapped />;
}

const DocumenDeliveryPageWrapped = () => {
  const [status, setStatus] = useState<UpdateStatus>("ok");

  return (
    <>
      <EditPageTemplate
        heading="Document delivery"
        message="Control how you receive your billing alerts and policy statements.
          Embrace the efficiency of paperless communication or continue continue
          receiving paper documents in your mailbox."
        unsavedChangesDialogHeading="Save document delivery changes?"
        pending={status == "pending"}
        isFormDirty={false} // TODO: Implement dirty check once select component is implemented
        hasValidationErrors={false} // TODO: Implement validation once select component is implemented
        showMutateError={status === "mutateError"}
        onClickSave={onClickSave}
      >
        <div className={styles.selectMethodText}>Select delivery method:</div>
        {/* TODO: Implement document delivery method selection */}
      </EditPageTemplate>
    </>
  );

  async function onClickSave(): Promise<void> {
    mt.trackAction({ actionType: "button", actionName: "save" });
    // Temporary until select component is implemented
    setStatus("ok");
    // Placeholder for save functionality once select component implemented
  }
};
